import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/perfilEmpleado/importer/perfilEmpleadoImporterActions';

export default importerReducers(actions);
